import { Component } from '@angular/core';

@Component({
    selector: 'ecp-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {}
